import {AfterViewInit, Component, OnInit} from '@angular/core';

import {NotificacoesService} from "../../services/notificacoes.service";
import {TipoDeNotificacaoEnum} from "../../../../server/domain/TipoDeNotificacaoEnum";
import {ConstantsService} from "../ConstantsService";

@Component({
  selector: 'app-noticacoes',
  templateUrl: './notificacoes.component.html',
  styleUrls: ['./notificacoes.component.css']
})
export class NotificacoesComponent implements OnInit, AfterViewInit {
  contato = {};
  notificacoesFidelidade = [];
  notificacoesPedidos = [];
  notificacoesSDR = [];
  notificacoesEntregas = [];

  loading = false;
  temModuloPedidos
  temModuloFidelidade
  constructor(private notificacoesService: NotificacoesService, private constantsService: ConstantsService) {
  }

  ngAfterViewInit() {
  }

  ngOnInit() {
    this.loading = true;
    this.constantsService.moduloPedido$.subscribe( data => this.temModuloPedidos = data)
    this.constantsService.moduloFidelidade$.subscribe( data => this.temModuloFidelidade = data)

    this.notificacoesService.todas().then( (notificacoes)  => {

      this.loading = false;

      this.notificacoesEntregas = this.filtreRemovendo(notificacoes,
        notificacao => notificacao.tipoDeNotificacao.indexOf('Entregador') >= 0)


      this.filtreRemovendo(notificacoes,  notificacao => notificacao.tipoDeNotificacao === 'Carrinho Abandonado');

      this.notificacoesPedidos = this.filtreRemovendo(notificacoes,  notificacao => notificacao.tipoDeNotificacao.indexOf('Pedido') >= 0 ||
        notificacao.tipoDeNotificacao.indexOf('Comanda') >= 0);



      this.notificacoesSDR = this.filtreRemovendo(notificacoes,  notificacao => notificacao.tipoDeNotificacao.indexOf('Etapa ') >= 0);


      this.notificacoesFidelidade = notificacoes
    });
  }

  filtreRemovendo(lista: [], funcaoFiltro) {
    let listaFiltrada = lista.filter(funcaoFiltro);

    listaFiltrada.forEach(function(element) {
      let  index = lista.indexOf(element)
      lista.splice(index, 1)
    })

    return listaFiltrada
  }

}
